// import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit, NgModule, Inject, OnInit} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { BrowserModule } from '@angular/platform-browser';
import { HttpService } from '../../http.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar} from '@angular/material/snack-bar';
import { AuthenticationService } from '../../_services';
import { first } from 'rxjs/operators';
import {MatButtonModule} from '@angular/material/button';
import {MatDivider} from '@angular/material/divider';
import {MatCardModule} from '@angular/material/card';
import { MatTooltipModule} from '@angular/material/tooltip';
import { MatBadgeModule} from '@angular/material/badge';

@Component({
  selector: 'app-supports',
  templateUrl: './supports.component.html',
  styleUrls: ['./supports.component.scss']
})
export class SupportsComponent implements OnInit {

  constructor(
    
  ) { }

  ngOnInit() {
  }

}


@Component({
  selector: 'supports-tab-1',
  templateUrl: './supports-tab-1.html',
  styleUrls: ['./supports.component.scss']

})
export class SupportsTab1 implements AfterViewInit {

 

  constructor(
      private formBuilder: FormBuilder,
      private _httpClient: HttpClient,
      public dialog: MatDialog,
      private snackBar: MatSnackBar,
      private authenticationService: AuthenticationService
  ) { }


  ngOnInit() {
   

  }

 
  ngAfterViewInit() {
    
  }



}

@Component({
  selector: 'supports-tab-2',
  templateUrl: './supports-tab-2.html',
  styleUrls: ['./supports.component.scss']

})
export class SupportsTab2 implements AfterViewInit {

 

  constructor(
      private formBuilder: FormBuilder,
      private _httpClient: HttpClient,
      public dialog: MatDialog,
      private snackBar: MatSnackBar,
      private authenticationService: AuthenticationService
  ) { }


  ngOnInit() {
   

  }

 
  ngAfterViewInit() {
    
  }



}

